(function () {
  if (window.__kitTierModalInit) return;
  window.__kitTierModalInit = true;

  document.querySelectorAll('[data-kit-tier-data]').forEach(function (dataEl) {
    var sectionId = dataEl.getAttribute('data-kit-tier-data');
    var modal = document.querySelector('[data-kit-modal="' + sectionId + '"]');
    if (!modal) return;

    var data = {};
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var triggers = document.querySelectorAll('#' + sectionId + ' [data-kit-tier-trigger]');
    var lastFocused = null;

    function openModal(power) {
      var entry = data[power];
      if (!entry) return;

      if (!entry.bundle) {
        window.location.href = entry.kit.url;
        return;
      }

      modal.querySelector('[data-modal-heading]').textContent = 'Complete your ' + entry.kit.title.replace('SuperVoltz ', '');
      modal.querySelector('[data-modal-kit-price]').textContent = entry.kit.price;
      modal.querySelector('[data-modal-kit-link]').href = entry.kit.url;
      var kitImage = modal.querySelector('[data-modal-kit-image]');
      if (entry.kit.image) {
        kitImage.src = entry.kit.image;
        kitImage.alt = entry.kit.title;
        kitImage.hidden = false;
      } else {
        kitImage.hidden = true;
      }

      var batteryLink = modal.querySelector('[data-modal-battery-link]');
      if (entry.battery) {
        batteryLink.href = entry.battery.url;
        modal.querySelector('[data-modal-battery-title]').textContent = entry.battery.title.replace('SuperVoltz ', '');
        modal.querySelector('[data-modal-battery-price]').textContent = entry.battery.price;
        batteryLink.hidden = false;
      } else {
        batteryLink.hidden = true;
      }

      modal.querySelector('[data-modal-bundle-title]').textContent = entry.bundle.title;
      modal.querySelector('[data-modal-bundle-price]').textContent = entry.bundle.price;
      modal.querySelector('[data-modal-bundle-link]').href = entry.bundle.url;
      var bundleImage = modal.querySelector('[data-modal-bundle-image]');
      if (entry.bundle.image) {
        bundleImage.src = entry.bundle.image;
        bundleImage.alt = entry.bundle.title;
        bundleImage.hidden = false;
      } else {
        bundleImage.hidden = true;
      }

      lastFocused = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      modal.querySelector('.kit-modal__close').focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openModal(trigger.getAttribute('data-power'));
      });
    });

    modal.querySelectorAll('[data-kit-modal-close]').forEach(function (closeEl) {
      closeEl.addEventListener('click', closeModal);
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  });
})();
